import postal from 'postal';
import React from 'react';
import mapboxgl from 'mapbox-gl';
import turfDistance from '@turf/distance';
import { FullscreenMapElevationPane } from '../search/fullscreen/map_elevation_pane';
import { IconMapLayerSelection } from '../search/fullscreen/icon_map_layer_selection';
import { IconMapOverlaySelection } from '../search/fullscreen/icon_map_overlay_selection';
import { MapMixin } from '../mixins/map/map_mixin';
import { getLines } from '../../../../utils/at_map_helpers';
import ZoomControls from '../../../../components/map_controls/ZoomControls';
import { fitMapToBounds } from '../../../../utils/mapbox/map_helpers';
import { addAtMap } from '../../../../utils/mapbox/overlays/at_map';

const createReactClass = require('create-react-class');

const PrintMap = createReactClass({
  mixins: [MapMixin],
  getInitialState() {
    return {
      currentMapLayer: this.props.mapLayer,
      enabledOverlays: []
    };
  },
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mapLoaded) {
      return;
    }
    if (!prevState.mapLoaded) {
      const { exploreMap } = this.props;
      if (exploreMap) {
        // Draw atMap
        const bounds = new mapboxgl.LngLatBounds();
        addAtMap(this.mbMap, exploreMap, this.renderWaypointPopup, bounds);
        // Only fit map to bounds if requested
        if (this.props.fitBounds) {
          fitMapToBounds(this.mbMap, bounds);
        }
      }
      if (this.props.enabledOverlays) {
        this.enableInitialOverlays(this.props.enabledOverlays);
      }
    }
    if (this.printMap) {
      this.printMap.handleMapLayerChanged(this.state.currentMapLayer);
    }
  },
  componentDidMount() {
    this.printJobHandler = null;
    $('#pdf-form').submit(e => {
      if (!this.printJobHandler) {
        this.printJobHandler = new AT.Print.PrintJobHandler($('#pdf-form'));
      }
      this.printJobHandler.submit(e, {
        enabled_overlays: this.state.enabledOverlays
      });
    });

    if (!this.listeners) {
      this.listeners = [];
    }
    this.initMap();
    this.printMap = new AT.Print.PrintMap(this.mbMap, this.props.containerSelector, this, {
      metric: this.props.displayMetric,
      showTrailHead: this.props.showTrailHead,
      marker: this.props.markerLatLon,
      elevationPolylinePoints: this.props.elevationPolylinePoints,
      elevationGain: this.props.elevationGain
    });
  },
  distanceBetween(lngLat1, lngLat2) {
    return 1000.0 * turfDistance(lngLat1, lngLat2);
  },
  renderElevationPane() {
    const { exploreMap } = this.props;
    const lines = getLines(exploreMap);
    if (lines.length < 1) {
      return null;
    }
    return (
      <FullscreenMapElevationPane
        containerDivOverride="chart_div"
        displayMetric={this.props.context.displayMetric}
        elevationConfig={{
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
          lineColor: 'gray',
          areaColor: '#595952',
          tickColor: '#414141',
          textColor: '#414141',
          axisTextColor: '#414141',
          endLineColor: '#414141'
        }}
        getElevationData={false}
        handleMouseOver={this.handleElevationPaneMouseOver}
        height={77}
        map={exploreMap}
        showStatsGroup={false}
      />
    );
  },
  render() {
    const permissions = this.getPermissions();
    return (
      <div id="print-map" className="full-height">
        <div id="print-map-controls" className="at-noprint">
          <ZoomControls handleZoomInClick={this.zoomInClicked} handleZoomOutClick={this.zoomOutClicked} handleCurrLocClick={this.compassClick} />
        </div>
        {this.renderElevationPane()}
        <div id={this.props.mapDivId} className="full-height" />
        <div className="map-overlays-layers-controls">
          <IconMapOverlaySelection
            context={this.props.context}
            enabledOverlays={this.state.enabledOverlays}
            handleCardClick={this.toggleOverlay}
            handleResetClick={this.disableAllOverlays}
            permissions={permissions}
          />
          <IconMapLayerSelection
            context={this.props.context}
            currentMapLayer={this.state.currentMapLayer}
            handleCardClick={this.setLayer}
            mapLayerDisplayOrder={['alltrailsOutdoorsV2', 'alltrailsSatellite', 'worldparks', 'openstreet', 'roadmap', 'worldtopo', 'opencycle']}
            mapLayers={this.state.mapLayers}
            permissions={permissions}
          />
        </div>
      </div>
    );
  }
});

PrintMap.defaultProps = {
  mapDivId: 'fullscreen-search-map',
  mapProviderName: 'mapBox',
  messagingChannel: postal.channel('printMap_messagingChannel'),
  containerSelector: '#pdf-map-page',
  fitBounds: true,
  setPrintFlags: true,
  currentPage: 'PRINT',
  mapLayer: 'alltrailsOutdoorsV2'
};

export { PrintMap };
